/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  DengLuCanShu,
  GuangGaoZhuChaXunTiaoJian,
  GuangGaoZhuXiuGaiMiMaXinXi,
  ResponseApiAdvertiserSwitchUserDTO,
  ResponseApiAdvertiserUserDTO,
  ResponseApiBoolean,
  ResponseApiDengLuYanZhengMa,
  ResponseApiFangShuiQiangYanZhengTuPianXinXi,
  ResponseApiListAdvertiserUserInfoDTO,
  ResponseApiString,
  ResponseApiVoid,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class GuangGaoZhuJianQuanGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags GuangGaoZhuJianQuanGuanLi
   * @name GetUserListByAdvertiserIdUsingPost
   * @summary 获取广告主下所有用户列表
   * @request POST:/dsp-admin/api/auth/advertiser/accountList
   * @secure
   */
  getUserListByAdvertiserIdUsingPost = (
    queryDTO: GuangGaoZhuChaXunTiaoJian,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiListAdvertiserUserInfoDTO, void>({
      path: `/dsp-admin/api/auth/advertiser/accountList`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZhuJianQuanGuanLi
   * @name ChangePasswordUsingPost
   * @summary 修改密码
   * @request POST:/dsp-admin/api/auth/advertiser/changePassword
   * @secure
   */
  changePasswordUsingPost = (
    changePasswordDTO: GuangGaoZhuXiuGaiMiMaXinXi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiBoolean, void>({
      path: `/dsp-admin/api/auth/advertiser/changePassword`,
      method: "POST",
      body: changePasswordDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZhuJianQuanGuanLi
   * @name GetCodeUsingPost
   * @summary 获取验证码
   * @request POST:/dsp-admin/api/auth/advertiser/code
   * @secure
   */
  getCodeUsingPost = (params: RequestParams = {}) =>
    this.request<ResponseApiDengLuYanZhengMa, void>({
      path: `/dsp-admin/api/auth/advertiser/code`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZhuJianQuanGuanLi
   * @name GetImpersonateAdvertiserListUsingPost
   * @summary 获取附身切换广告主列表
   * @request POST:/dsp-admin/api/auth/advertiser/impersonate/advertiser
   * @secure
   */
  getImpersonateAdvertiserListUsingPost = (params: RequestParams = {}) =>
    this.request<ResponseApiAdvertiserSwitchUserDTO, void>({
      path: `/dsp-admin/api/auth/advertiser/impersonate/advertiser`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZhuJianQuanGuanLi
   * @name GetCurrentUserInfoUsingGet
   * @summary 获取当前登录用户信息
   * @request GET:/dsp-admin/api/auth/advertiser/info
   * @secure
   */
  getCurrentUserInfoUsingGet = (params: RequestParams = {}) =>
    this.request<ResponseApiAdvertiserUserDTO, void>({
      path: `/dsp-admin/api/auth/advertiser/info`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZhuJianQuanGuanLi
   * @name LoginUsingPost
   * @summary 用户登录
   * @request POST:/dsp-admin/api/auth/advertiser/login
   * @secure
   */
  loginUsingPost = (loginRequest: DengLuCanShu, params: RequestParams = {}) =>
    this.request<ResponseApiAdvertiserUserDTO, void>({
      path: `/dsp-admin/api/auth/advertiser/login`,
      method: "POST",
      body: loginRequest,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZhuJianQuanGuanLi
   * @name LogoutUsingPost
   * @summary 用户登出
   * @request POST:/dsp-admin/api/auth/advertiser/logout
   * @secure
   */
  logoutUsingPost = (params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/auth/advertiser/logout`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZhuJianQuanGuanLi
   * @name SendEmailCodeUsingPost
   * @summary 发送邮箱验证码
   * @request POST:/dsp-admin/api/auth/advertiser/sendCode
   * @secure
   */
  sendEmailCodeUsingPost = (
    query: {
      /** 邮箱地址 */
      email: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/auth/advertiser/sendCode`,
      method: "POST",
      query: query,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZhuJianQuanGuanLi
   * @name GetRandomVerificationImageUsingPost
   * @summary 获取随机防水墙验证图片信息
   * @request POST:/dsp-admin/api/auth/advertiser/verification/image
   * @secure
   */
  getRandomVerificationImageUsingPost = (params: RequestParams = {}) =>
    this.request<ResponseApiFangShuiQiangYanZhengTuPianXinXi, void>({
      path: `/dsp-admin/api/auth/advertiser/verification/image`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZhuJianQuanGuanLi
   * @name GetAdvertiserTokenInfoUsingPost
   * @summary 附身到广告主（自动检查权限）
   * @request POST:/dsp-admin/api/auth/advertiser/{advertiserId}/impersonate
   * @secure
   */
  getAdvertiserTokenInfoUsingPost = (
    advertiserId: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiString, void>({
      path: `/dsp-admin/api/auth/advertiser/${advertiserId}/impersonate`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new GuangGaoZhuJianQuanGuanLi();
